export const isOwnerLoggedIn = () => !!localStorage.getItem('ownerAccessToken');
